import React from 'react';
import logo from '../../assets/icons/logo.svg';
import './Footer.scss';
import { FaFacebookF, FaInstagram} from "react-icons/fa";
import { Link } from 'react-router-dom';
import {FaPhoneAlt} from "react-icons/fa";
import {MdOutlineAccessTimeFilled} from "react-icons/md";
import {FaLocationDot} from "react-icons/fa6";
import bgLogo from '../../assets/icons/Vector.svg';
const Footer = () => {

    const footerMenu = [
        {
            'name' : 'Strona Główna',
            'link' : '/'
        },
        {
            'name' : 'O Nas',
            'link' : '/o-nas'
        },
        {
            'name' : 'Oferta',
            'link' : '/oerta'
        },
        {
            'name' : 'Cennik',
            'link' : '/cennik'
        },
        {
            'name' : 'Kontakt',
            'link' : '/kontakt'
        }
    ];

    return (
        <footer className='footer section-p section-mt'>
             <img className='bg-logo' src={bgLogo} alt="zlota centrum zdrowia logo" />
            <div className="container">
               
                <div className="footer-items">
                    <div className="footer-items-socialmedia">
                        <div className="footer-logo">
                            <img src={logo} alt="zlota centrum zdrowia logo" />
                        </div>
                        <div className="social-logo">
                            <p>Odwiedź nas:</p>
                            <ul>
                                <li><a href="https://www.facebook.com/profile.php?id=61564445368592"><FaFacebookF size={24}/></a></li>
                                <li><a href="https://www.instagram.com/zlota.centrum.zdrowia/?fbclid=IwY2xjawIjQhRleHRuA2FlbQIxMAABHa1gp1bIWUFspmXWImJo9VlTaWVRbdH1Dw3xcp4RnhJ7JaXn-CWlroB-ig_aem_wqGTq5xg42L4_DN50qttpw"><FaInstagram size={24}/></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-items-menu">
                        <div className="footer-link">
                            <p>Menu</p>
                            <ul>
                                {
                                    footerMenu.map(singleMenu => <li key={singleMenu.name}><Link to={singleMenu.link}><span>{singleMenu.name}</span></Link></li>)
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="footer-items-contact">
                        <div className="footer-contact">
                            <p>Informacje kontakowe</p>
                                        <a href="tel:+48782949818">
                                      <div className="contact-list">
                                                <div className="contact-icon">
                                                <FaPhoneAlt size={24} />
                                                </div>
                                                <div className="contact-text">
                                                    <p>Rejestracja telefoniczna</p>
                                            <h5>+48 782 949 818</h5>
                                            {/* {footerContact.info2 && <h5>{footerContact.info2}</h5>} */}
                                                </div>
                                            </div>
                            </a>
                                      <div className="contact-list">
                                                <div className="contact-icon">
                                                <MdOutlineAccessTimeFilled size={24} />
                                                </div>
                                                <div className="contact-text">
                                                    <p>Godziny rejestracji telefonicznej</p>
                                            <h5>Pon-Pt od 8:00 do 20:00</h5>
                                            <h5>Sobota od 8:00 do 18:00</h5>
                                                </div>
                                            </div>
                                      <div className="contact-list">
                                                <div className="contact-icon">
                                                <FaLocationDot size={24} />
                                                </div>
                                                <div className="contact-text">
                                                    <p>Adres</p>
                                            <h5>28-400 Pińczów, ul. Złota 11</h5>
                                                </div>
                                            </div>
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                    <div className='copy-text'>
                        <p>&copy; Złota Centrum Zdrowia. 2025 Wszelkie prawa zastrzeżone</p>
                    </div>  
                    <div className='copy-links'>
                        <Link target='_blank' to='/regulamin.pdf'>Regulamin</Link>
                    </div>                          
                </div>
            </div>
        </footer>
    );
};

export default Footer;